import { invokeApi } from "../Utils/InvokeApi";
import { invokeApi2 } from "../Utils/InvokeApi2";

export const createnewAdmin = async (data) => {
  const reqObj = {
    path: `/user/admin/create`,
    method: "POST",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
    postData: data,
  };
  return invokeApi(reqObj);
};
export const createnewPermision = async (data) => {
  const reqObj = {
    path: `/permission`,
    method: "POST",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
    postData: data,
  };
  return invokeApi(reqObj);
};
export const createnewCategory = async (data) => {
  const reqObj = {
    path: `/add-product-categories`,
    method: "POST",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
    postData: data,
  };
  return invokeApi2(reqObj);
};
export const uploadFile = async (data) => {
  const reqObj = {
    path: `/image`,
    method: "POST",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
      "Content-Type": "multipart/form-data",
    },
    postData: data,
  };
  return invokeApi(reqObj);
};
export const uploadGift = async (data) => {
  const reqObj = {
    path: `/gift`,
    method: "POST",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
    postData: data,
  };
  return invokeApi(reqObj);
};
export const uploadFamilyRule = async (data) => {
  const reqObj = {
    path: `/create-family-rule`,
    method: "POST",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
    postData: data,
  };
  return invokeApi2(reqObj);
};
export const uploadProduct = async (data) => {
  const reqObj = {
    path: `/create-product`,
    method: "POST",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
    postData: data,
  };
  return invokeApi2(reqObj);
};
export const AddCustomerSupport = async (data) => {
  const reqObj = {
    path: `/add-customer-support`,
    method: "POST",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
    postData: data,
  };
  return invokeApi2(reqObj);
};
export const createnewTag = async (data) => {
  const reqObj = {
    path: `/create-tag`,
    method: "POST",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
    postData: data,
  };
  return invokeApi2(reqObj);
};
export const createHostingLevelTag = async (data) => {
  const reqObj = {
    path: `/assign-host-level`,
    method: "POST",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
    postData: data,
  };
  return invokeApi2(reqObj);
};

export const uploadAgency = async (data) => {
  const reqObj = {
    path: `/agency`,
    method: "POST",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
    postData: data,
  };
  return invokeApi(reqObj);
};
export const AddBussinessDeveloper = async (data) => {
  const reqObj = {
    path: `/business-developer`,
    method: "POST",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
    postData: data,
  };
  return invokeApi(reqObj);
};
export const CreateSenderLevel = async (data) => {
  const reqObj = {
    path: `/create-sender-level-info`,
    method: "POST",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
    postData: data,
  };
  return invokeApi2(reqObj);
};
export const CreateHostLevel = async (data) => {
  const reqObj = {
    path: `/create-host-level-info`,
    method: "POST",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
    postData: data,
  };
  return invokeApi2(reqObj);
};
export const CreateDiamondPackages = async (data) => {
  const reqObj = {
    path: `/package`,
    method: "POST",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      //  "Content-Type":"multipart/form-data",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
    postData: data,
  };
  return invokeApi(reqObj);
};

export const updateMomentVideoStatus = async (id, data) => {
  const reqObj = {
    path: `/update-video-status/${id}`,
    method: "PATCH",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
    postData: data,
  };
  return invokeApi2(reqObj);
};
export const updateMomentStatus = async (id, data) => {
  const reqObj = {
    path: `/accept-moment/${id}`,
    method: "POST",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
    postData: data,
  };
  return invokeApi2(reqObj);
};
export const updateUSerProfileStatus = async (id, status) => {
  const reqObj = {
    path: `/user/admin/approve-profile-update/${id}/${status}`,
    method: "PATCH",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
  };
  return invokeApi(reqObj);
};
export const AddBubbleImage = async (data) => {
  const reqObj = {
    path: `/create-text-bubble`,
    method: "POST",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
    postData: data,
  };
  return invokeApi2(reqObj);
};
export const AddBannerImage = async (data) => {
  const reqObj = {
    path: `/image/create-banner`,
    method: "POST",
    headers: {
      "app-version": "2.4.0",

      "Content-Type": "multipart/form-data",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
    postData: data,
  };
  return invokeApi(reqObj);
};
export const AddSpecialRID = async (data) => {
  const reqObj = {
    path: `/create-special-rid`,
    method: "POST",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
    postData: data,
  };
  return invokeApi2(reqObj);
};
export const AddProfileTag = async (data) => {
  const reqObj = {
    path: `/create-profile-tag`,
    method: "POST",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
    postData: data,
  };
  return invokeApi2(reqObj);
};
export const AssignStreamTag = async (data) => {
  const reqObj = {
    path: `/assign-user-stream-tag`,
    method: "POST",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
    postData: data,
  };
  return invokeApi2(reqObj);
};
export const AssignProfileTag = async (data) => {
  const reqObj = {
    path: `/add-user-tag`,
    method: "POST",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
    postData: data,
  };
  return invokeApi2(reqObj);
};
export const AddDiamonds = async (data) => {
  const reqObj = {
    path: `/send-diamond`,
    method: "POST",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
    postData: data,
  };
  return invokeApi2(reqObj);
};
export const AssignSenderLevel = async (data) => {
  const reqObj = {
    path: `/assign-sender-level`,
    method: "POST",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
    postData: data,
  };
  return invokeApi2(reqObj);
};
export const AssignHostLevelData = async (data) => {
  const reqObj = {
    path: `/assign-host-level`,
    method: "POST",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
    postData: data,
  };
  return invokeApi2(reqObj);
};
export const uploadMerchand = async (data) => {
  const reqObj = {
    path: `/create-merchant`,
    method: "POST",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
    postData: data,
  };
  return invokeApi2(reqObj);
};
export const createWithdrawPayment = async (data) => {
  const reqObj = {
    path: `/withdraw-payment-method`,
    method: "POST",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
    postData: data,
  };
  return invokeApi2(reqObj);
};
export const CreateBannerApi = async (data) => {
  const reqObj = {
    path: `/create-banner`,
    method: "POST",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
    postData: data,
  };
  return invokeApi2(reqObj);
};
export const UpdateBannerStatusApi = async (id) => {
  const reqObj = {
    path: `/active-banner/${id}`,
    method: "POST",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
  };
  return invokeApi2(reqObj);
};
export const UpdateCustomerStatusApi = async (id, data) => {
  const reqObj = {
    path: `/change-customer-status/${id}`,
    method: "PATCH",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
    postData: data,
  };
  return invokeApi2(reqObj);
};
export const UpdateAgencyStatus = async (id, data) => {
  const reqObj = {
    path: `/accept-host-request/${id}`,
    method: "PATCH",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
    postData: data,
  };
  return invokeApi2(reqObj);
};
export const SendText = async (data) => {
  const reqObj = {
    path: `/send-message`,
    method: "POST",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
    postData: data,
  };
  return invokeApi2(reqObj);
};
export const AddSvipData = async (data) => {
  const reqObj = {
    path: `/vip`,
    method: "POST",
    headers: {
      "app-version": "2.4.0",
      "app-platform": "ios",
      Authorization: `Bearer ${localStorage.getItem(
        "rocco_live-access-Token-for-web"
      )}`,
    },
    postData: data,
  };
  return invokeApi(reqObj);
};
